import type { Entry } from 'contentful'

import type {
  FooterLink,
  FooterLinkGroup,
  NavbarProps,
} from '@cbhq/cdx-components'

import { mapFooterProps } from './footer'
import type { CDXSettingsFooterFields } from './footer'
import { mapMicrocopyProps } from './microcopy'
import type {
  CDXSettingsMicrocopyGroupFields,
  ContentfulMicrocopyValues,
} from './microcopy'
import { mapNavbarProps } from './navbar'
import type { CDXSettingsNavbarFields } from './navbar'
import { mapEntryLink } from './navlink'
import type { CDXSettingsNavLinkFields } from './navlink'
import { getEntryProps } from '../utils/getEntryProps'

export const CDX_SETTINGS_SITE_CONTENT_MODEL_ID = 'cdxSettingsSite'

export type CDXSettingsSiteFields = {
  footer?: Entry<CDXSettingsFooterFields>
  navbar?: Entry<CDXSettingsNavbarFields>
  bannerText?: string
  bannerLink?: Entry<CDXSettingsNavLinkFields>
  microcopies: Entry<CDXSettingsMicrocopyGroupFields>
}

export type SiteConfigProps = {
  navbar: NavbarProps
  footer: {
    socialMediaLinks: FooterLink[]
    columnOne: FooterLinkGroup[]
    columnTwo: FooterLinkGroup[]
    columnThree: FooterLinkGroup[]
  }
  banner: {
    label: string
    buttonLabel?: string
    buttonUrl?: string
  }
  microcopies?: ContentfulMicrocopyValues
}

export const getSiteConfigProps = (
  siteConfig: Entry<CDXSettingsSiteFields> | undefined,
): SiteConfigProps => {
  const { footer, navbar, bannerText, bannerLink, microcopies } = getEntryProps(
    siteConfig,
    {},
  )

  const navbarProps = mapNavbarProps(navbar)
  const bannerButton = bannerLink ? mapEntryLink(bannerLink) : undefined

  return {
    footer: mapFooterProps(footer),

    navbar: navbarProps,

    banner: {
      label: bannerText || '',
      buttonLabel: bannerButton?.label || undefined,
      buttonUrl: bannerButton?.url || undefined,
    },

    microcopies: mapMicrocopyProps(microcopies),
  }
}

export const getSiteConfigMicrocopies = (
  siteConfig: Entry<CDXSettingsSiteFields> | undefined,
) => {
  const { microcopies } = getEntryProps(siteConfig)

  return mapMicrocopyProps(microcopies)
}
